import { Skeleton } from '@repo/ui/skeleton';
import { cn } from '@repo/utils/cn';
import { memo } from 'react';

type CardSkeletonProps = {
  className?: string;
};

const CardSkeleton = ({ className }: CardSkeletonProps) => {
  return (
    <div className={cn('h-full', 'w-full', className)}>
      <div className="flex h-full flex-col items-center justify-between space-y-3">
        <div className="flex h-full w-3/4 items-center justify-center">
          <Skeleton className="h-20 w-20 rounded-full" />
        </div>
        <div className="flex h-1/4 w-full flex-col items-center justify-center space-y-1.5 px-1.5">
          <div className="flex w-full items-center justify-center space-x-1.5">
            <Skeleton className="h-3 w-3/4 rounded-none" />
            <Skeleton className="h-3 w-1/4 rounded-none" />
          </div>
          <div className="flex w-full items-center justify-center space-x-1.5">
            <Skeleton className="h-3 w-3/4 rounded-none" />
            <Skeleton className="h-3 w-1/4 rounded-none" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default memo(CardSkeleton);
